import { render, staticRenderFns } from "./Speedtest.vue?vue&type=template&id=1c20ac70"
import script from "./Speedtest.vue?vue&type=script&lang=js"
export * from "./Speedtest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports